module.exports = __webpack_public_path__ + "static/media/0010_LE_PLAFOND_RAL_9010.d4d438bb.webp";